define ['./appCard.css'], () ->
  uniqueId = 1;
  ($rootScope, $localStorage, $state, RENTAPPLICATION_API_URL, $timeout, $document, RentappService) ->
    restrict: "E"
    template: require("./appCard.jade")
    scope: { layout: "@", cardmodel: "=" }
    link: (scope, element, attrs) ->
      #Create an instance of Elements.
      RentappService.getStripe()
        .then (stripe) ->
          elements = stripe.elements();

          style = {
            base: {
              lineHeight: '18px',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#aab7c4'
              }
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          };

          # Create an instance of the card Element.
          card = elements.create('card', {style: style})

          #Add an instance of the card Element into the `card-element` <div>.
          card.mount('#card-element')

          card.on('ready', (event) ->
            card.addEventListener('change', (event) ->
              displayError = document.getElementById('card-errors')

              if event.error
                displayError.textContent = event.error.message
              else 
                displayError.textContent = ''
            )
          )
          scope.cardmodel = card
          scope.cardmodel.payment_receipt = true
      
      $rootScope.$on "card-error", (event, data) ->
        displayError = document.getElementById('card-errors')
        displayError.textContent = data.message


// WEBPACK FOOTER //
// ./directives/appCard/appCard.coffee